
app.service('dispatcher', function (captchaService, cartRetrieve, reportBug, simpleToastr, lazyLoad, regulations,
    operator, partnerBar, energyLabel, dataSeoUrl, simpleModal,
	tooltip, log, front, broker, holidayPromotion, select, relatedPromotionCommercial) {

	function run() {
		// skrypty uruchamiane po wymianie strony, po każdym zaciągnięciu strony ajaxowo
		setViewMode();
		select.resetElements();
		captchaService.init();
		log.visit();
		wdioRandom();
	}
	function init() {
		//--------   tutaj zweryfikowane jednokrotnie wywołane
		select.init();
		reportBug.init();
		simpleModal.init();
		simpleToastr.init();
		lazyLoad.init();
		tooltip.init();
		holidayPromotion.init();
		relatedPromotionCommercial.init();
		energyLabel.init();
		dataSeoUrl.init();
		operator.init();
		cartRetrieve.init();
		partnerBar.init();
		broker.on('PAGE_CHANGE', function () {
			run()
		});
		$('body').on('click', '.js-regulations', function (event) {
			regulations.show();
			event.preventDefault();
			event.stopPropagation();
		}).on('focus', '.row-input .column', function () {
			$(this).addClass('input-focus');
		}).on('blur', '.row-input .column', function () {
			$(this).removeClass('input-focus');
		}).on('click', '[href="#"]', function (event) {
			event.preventDefault();
		}).on('click', '.checkbox-css p.less a, .checkbox-css p.more a', function () {
			$(this).closest('.checkbox-css').toggleClass('checkbox-css-more');
		}).on('paste keyup change', 'textarea[maxlength]', function () {
			$('.char-counter-current', $(this).parent()).text($(this).val().length);
		}).on('click', '.js-toogle-password-type', function () {
			let $this = $(this);
			let $input = $this.prev()
			if ($input.attr('type') == 'password') {
				$input.attr('type', 'text');
				$this.text($this.data('hide'));
			} else {
				$input.attr('type', 'password');
				$this.text($this.data('show'));
			}
		}).on('click', '.js-print', function () {
			window.print();
		}).on('keyup', 'input[name*="companyName"]', function () {			// gdy pierwsze pole firma osiągnie swój limit zostaje przeniesione do drugiego pola
			var $this = $(this);
			if ($(this).val().length == $(this).attr('maxlength')) {
				let name = $this.attr('name');
				let newName = name.replace("Part1", "Part2");
				if (newName != name) {
					let $cont = $('input[name="' + newName + '"]');
					if ($cont.length) {
						console.log('osiągnięto limit w pierwszym polu firma, przeskok do pola: ' + newName);
						$cont.click().click().focus();
					}
				}
			}
		}).on('keypress', '.radio-css > i', function(event){
			if(event.originalEvent.code=='Enter'){
				$(this).prev('input').not(':disabled').trigger('click');
			}
		}).on('keypress', 'label.checkbox-css', function(event){
			if(event.originalEvent.code=='Enter'){
				$(this).find('input:checkbox').not(':disabled').trigger('click');
			}
		});
		window.addEventListener('resize', function () {
			setViewMode();
		});

		broker.on('WDIO-PAGE-REFRESH', function () {
			wdioRandom();
		});
		run();
	}
	function wdioRandom() {
		$('body').attr('wdio-random', parseInt(Math.random() * 100000000));
	}
	function setViewMode() {
		let $viewMode = $('#view-mode');
		if ($viewMode.length) {
			$viewMode.val(front.getBrakepoint());
		} else {
			let $form = $('body form').first();
			if ($form.length) {
				$form.prepend('<input type="hidden" id="view-mode" name="viewMode" value="" />');
				setViewMode();
			}
		}
	};
	return {
		init
	}
});